import React, { memo } from "react";
import { useImagesPreloader } from "./index.hooks";
import { Box } from "@mui/material";

type ImagesPreloaderProps = {};

export const ImagesPreloader = memo(({}: ImagesPreloaderProps) => {
  const { imagesUrls } = useImagesPreloader();

  return (
    <div>
      {imagesUrls.map((url) => (
        <Box key={url} component="img" src={url} sx={{ display: "none" }} />
      ))}
    </div>
  );
});
